import React, { type ReactNode } from 'react';

interface Props {
  destination: string;
  children: ReactNode;
}

const ExternalLink = ({ destination, children }: Props) => (
  <a
    onClick={() => location.reload}
    href={destination}
    style={{ textDecoration: 'none' }}
  >
    {children}
  </a>
);

export default ExternalLink;
